'use strict';

module.exports = function () {
    $('body').on('click', '.bv-buynow-conversion', function () {
        var $button = $(this);

        var productId = $button.siblings('[data-pid]').data('pid') ||$button.closest('[data-pid]').data('pid');

        if (!productId) {
            return;
        }

        if (typeof BV !== 'undefined' && 
            BV.pixel && 
            typeof BV.pixel.trackConversion === 'function') {
            
            try {
                BV.pixel.trackConversion({
                    'type': 'BuyNow',
                    'label': productId,
                    'value': 'Buy Now'
                });
            } catch (error) {
                console.error('Bazaarvoice tracking error:', error);
            }
        }
    });
};
